export default __webpack_public_path__ + "static/agent-default-cb6de380671ed3dcf816b1ce6cd4046e.png";